module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-03-d60f3f299f68733496fbededd7fe56dd.jpg";